export default function initMeter() {
  const ANIMATION_THRESHOLD = 200;
  const windowHeight = window.innerHeight;

  const meters = document.querySelectorAll(".js-meter");

  if (meters) {
    meters.forEach((component) => {
      // Get the meter overlay and its tooltip/bubble
      const overlay = component.querySelector(".js-meter-bar-overlay");
      const tooltip = component.querySelector(".js-meter-tooltip");

      // Calculate the width of the overlay;
      // will be applied in checkForAnimation function
      const currentAmount = component.getAttribute("data-current");
      const goalAmount = component.getAttribute("data-goal");
      const overlayWidth = currentAmount / goalAmount;

      // Do some math to get the location of the component on the screen,
      // and check for when the animation should trigger.
      const componentLocation =
        component.getBoundingClientRect().top +
        document.documentElement.scrollTop;
      const animateAt = componentLocation + ANIMATION_THRESHOLD;

      const checkForAnimation = () => {
        overlay.style.width = 0;
        if (tooltip.classList.contains("is-visible")) {
          tooltip.classList.remove("is-visible");
        }

        const distanceFromBottomOfScreen = window.scrollY + windowHeight;

        if (
          (distanceFromBottomOfScreen * 0.99 < animateAt &&
            distanceFromBottomOfScreen * 1.01 > animateAt) ||
          distanceFromBottomOfScreen > animateAt
        ) {
          if (overlayWidth === 1) {
            console.log(true);
            overlay.classList.add("meter__bar-overlay--full");
          }

          overlay.style.width = overlayWidth * 100 + "%";
          tooltip.classList.add("is-visible");

          window.removeEventListener("scroll", checkForAnimation);
        }
      };

      window.addEventListener("scroll", checkForAnimation);
    });
  } else {
    return;
  }
}
